export const AppointmentLiveBoardGroup: {
    INITIAL: 'INITIAL',
    ARRIVED: 'ARRIVED',
    SKINSCANNER: 'SKINSCANNER',
    PREPARATION: 'PREPARATION',
    TREATMENT: 'TREATMENT',
    FINALIZING: 'FINALIZING',
} = {
    INITIAL: 'INITIAL',
    ARRIVED: 'ARRIVED',
    SKINSCANNER: 'SKINSCANNER',
    PREPARATION: 'PREPARATION',
    TREATMENT: 'TREATMENT',
    FINALIZING: 'FINALIZING',
};

export type AppointmentLiveBoardGroup = (typeof AppointmentLiveBoardGroup)[keyof typeof AppointmentLiveBoardGroup];

export const getAppointmentLiveBoardGroupLabel = (status: AppointmentLiveBoardGroup): string => {
    switch (status) {
        case AppointmentLiveBoardGroup.INITIAL:
            return 'INITIAL';
        case AppointmentLiveBoardGroup.ARRIVED:
            return 'ARRIVED';
        case AppointmentLiveBoardGroup.SKINSCANNER:
            return 'SKINSCANNER';
        case AppointmentLiveBoardGroup.PREPARATION:
            return 'PREPARATION';
        case AppointmentLiveBoardGroup.TREATMENT:
            return 'TREATMENT';
        case AppointmentLiveBoardGroup.FINALIZING:
            return 'FINALIZING';
        default:
            return 'Unbekannter';
    }
};